module.exports = __webpack_public_path__ + "static/media/Reserves.eb3ba05d.svg";